import { Container, Grid, Typography, makeStyles } from "@material-ui/core";
import { getOrderDate } from "../utils";
import { ITheme } from "../constants/theme";
import { useTranslation } from 'react-i18next';

export const OrderDetailsHistorySection = (props: any) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const data: any = props.data;

  const getProLabel = (data) => {
    // Avoid showing duplicate TK Pro Rejected label
    if(data?.OrderManagerRejected) {
      return null;
    }

    if (data?.ProOrderStatus?.length > 0) {
      return data?.ProOrderStatus;
    }

    if (data?.OrderPaymentStatus === 'Succeeded') {
      return t('admin.paymentSucceeded');
    }

    if (data?.OrderPaymentStatus === 'Failed') {
      return t('admin.paymentFailed');
    }
  };

  const statuses = [
    { label: t('admin.orderPlaced'), value: data?.Created },
    { label: getProLabel(data), value: data?.OrderPaymentDate },
    { label: t('admin.pending'), value: data?.Pending },
    { label: t('admin.pendingApproval'), value: data?.OrderPendingApproval },
    { label: t('admin.approved'), value: data?.OrderManagerApproved },
    { label: t('admin.customerCancelled'), value: data?.Cancelled },
    { label: t('admin.rejectedByShop'), value: data?.Rejected },
    { label: t('admin.packed'), value: data?.Packed },
    { label: t('admin.queued'), value: data?.Queued },
    { label: t('admin.assigned'), value: data?.Assigned },
    { label: t('admin.dispatched'), value: data?.Dispatched },
    { label: t('admin.rejectedByTkProManager'), value: data?.OrderManagerRejected },
    { label: t('admin.failed'), value: data?.Failed },
    { label: t('admin.cancelled'), value: data?.OrderCancelled },
    { label: t('admin.atPickupLocation'), value: data?.AtPickUpLocation },
    { label: t('admin.outForDelivery'), value: data?.OutForDelivery },
    { label: t('admin.atDropOffLocation'), value: data?.AtDropOffLocation },
    { label: t('admin.delivered'), value: data?.Delivered },
    { label: t('admin.returned'), value: data?.Returned },
  ].filter(s => Boolean(s.value) && Boolean(s.label));

  return (
    <Container className={classes.basicInformationContainer}>
      <Grid container>
        <Grid container className={classes.infoTitle}>
          <Typography variant="h6" component="span">
{t('admin.orderHistory')}
          </Typography>
        </Grid>
        {statuses.map(s =>
          <Grid key={s.label} container className={classes.infoTextContainer}>
            <Grid item xs={3} style={{ paddingRight: '24px' }}>
              <Typography
                display="inline"
                variant="caption"
                component="span"
                color="textSecondary"
                style={{ textTransform: 'uppercase' }}>
                {s.label}
              </Typography>
            </Grid>
            <Grid item xs={7} className={classes.colOffset}>
              <Typography variant="body1" component="span" color="textPrimary">
                {getOrderDate(s.value)}
              </Typography>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

const useStyles = makeStyles((theme: ITheme) => ({
  basicInformationContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    marginTop: "24px",
    padding: "18px 24px 0",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    boxSizing: "border-box",
    borderRadius: "20px",
  },
  infoTitle: {
    marginBottom: 20,
  },
  infoTextContainer: {
    paddingTop: 15,
    paddingBottom: 15,
    '&:not(:last-child)': {
      borderBottom: "1px solid rgba(0, 0, 0, 0.08)"
    }
  },
  infoTextContainerLastRow: {
    paddingTop: 15,
    paddingBottom: 15,
  },
  colOffset: {
    marginLeft: -17.5,
    marginRight: 17.5,
  },
}));
